export default {
  presenter: 'sojka',
  title: 'Zabezpečení služeb v OpenWrt',
  subtitle: 'mírně pokročilí',
  text: `
Většina služeb na routerech s OpenWrt není nijak zvlášť zabezpečena a úspěšný útok na libovolnou
ze služeb může mít za následek kompromitaci celého routeru. V přednášce si povíme o nových
vlastnostech OpenWrt, které umožňují spouštět služby v sandboxu (jailu). Podíváme se na to,
jak jsou sandboxy implementovány (seccomp, namespaces), jak se konfigurují a jak je možné ladit
případné problémy.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/sojka-openwrt.js